export default __webpack_public_path__ + "static/media/image6.f19903a3.jpg";